<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <div class="row">
      <div class="col-xl-12">
        <div class="dash-head-wrap d-flex justify-content-between align-items-center">
          <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">Skill Certificates <img v-if="!isSafeDig" src="/signup-img/fire.svg" alt="">
            </h2>
            <!-- <p class="text-secondary">let's dive into your personalized setup guide.</p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="card top-cardheader">

      <div class="row m-0">
        <div class="col-xl-6 col-md-6 p-0" @click="openActive" style="cursor: pointer;">
          <!--                    <router-link class="nav-item" to="/company_locations">-->
          <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="certificateIcons.active" />
              </div>
              <div class="card-left flex-grow-1 pl-3
                                    ">
                <h5 class="font-weight-normal m-0" name="New employee">Active Certificates</h5>
                <span name="New employee">{{ active_cer }}</span>

              </div>

            </div>
          </div>
          <!--</router-link>-->
        </div>
        <div class="col-xl-6 col-md-6 p-0" @click="openExpired" style="cursor: pointer;">
          <div class="dash-card-box shadow-none border-0 rounded-0 px-3 px-sm-4 mb-0">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="certificateIcons.expired" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0">Expired Certificates</h5>
                <span>{{ expire_cer }}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="activated-certificate" v-if="is_active_show">
      <div>
        <card class="no-border-card card-with-table" footer-classes="pt-1">
          <div class="row align-items-center">
            <div class="col-md-6">
              <h2 class="mb-1 px-4">Active Certificates</h2>
            </div>

            <div class="col-md-6 text-right">
              <template v-if="isCertficateChecked">
                <a :href="baseUrl +
                  '/downloadAllCourseCertificate/single/' +
                  checked_certificate.join('_') +
                  '/' +
                  user_id
                  " class="btn base-button custom-btn btn-default" type="primary">Download<i
                    class=" fa fa-download"></i></a>
              </template>
            </div>
          </div>
          <div>
            <div class="row">
              <div class="col-sm-12 mt-2">
                <div class="user-eltable table-style-normal no-header-bg">
                  <!-- :data="expiredData" -->
                  <el-table :data="queriedData" row-key="id" role="table" class="certificatesGrid"
                    header-row-class-name="thead-light custom-thead-light" @sort-change="sortChange"
                    @selection-change="selectionChange">
                    <el-table-column min-width="250px" align="left" label="Course Name">
                      <template slot-scope="props">
                        <span>{{ props.row.certificate_name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200px" align="left" label="Completion Date">
                      <template slot-scope="props">
                        <span class="lesson-status-open">{{
                          formattedDate(props.row.certificate_date)
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200px" align="left" label="Expiration Date">
                      <template slot-scope="props">
                        <span class="lesson-status-expired">{{
                          formattedDate(props.row.certificate_expiration_date)
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200px" align="left" label="Action">
                      <div slot-scope="{ row }" class="actions-container">
                        <el-tooltip content="Preview" placement="top">
                          <base-button v-if="row.is_proctored_exam == 1" @click.prevent="getProctoredExamCertificate(
                            row.certificate_url,
                            2
                          )" class="success" type="" size="sm" icon data-toggle="tooltip"
                            data-original-title="Preview">
                            <i class="text-success fa fa-eye" v-if="!row.show_loader"></i>
                            <i class="text-success fas fa-spin fa-spinner" v-if="row.show_loader"></i>
                          </base-button>
                          <base-button v-else
                            @click="generatePreviewCertificate(row.course_id, user_id, row.id, row.is_coursefolder)"
                            class="success" type="" size="sm" icon data-toggle="tooltip" data-original-title="Preview">
                            <img class="ico-eye" src="/img/icons/common/eye_icon.svg" alt="" />
                          </base-button>
                        </el-tooltip>
                        <el-tooltip content="Download" placement="top">
                          <base-button v-if="
                            row.is_proctored_exam != 1
                          " @click="generateDownloadCertificate(row.course_id, user_id, row.id, row.is_coursefolder)"
                            class="warning" type="" size="sm" icon data-toggle="tooltip" data-original-title="Download">
                            <img class="ico-download" src="/img/icons/common/download_icon.svg" alt="" />
                          </base-button>
                        </el-tooltip>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="uploaded--certificate" v-if="is_uploaded_show">
      <div>
        <card class="no-border-card card-with-table" footer-classes="pt-1">

          <div>
            <div class="row">

              <div class="col-sm-12 mt-2">
                <div class="user-eltable table-style-normal no-header-bg">
                  <h2 class="mb-3 px-4">Uploaded Certificates</h2>
                  <el-table header-row-class-name="thead-light custom-thead-light"
                    class="thead-light custom-thead-light addcertificatesGrid" role="table" :data="tbl2_data">
                    <!-- <el-table-column min-width="100px" label="">
                                          <template slot-scope="props">
                                            <span>
                                              <input
                                                type="checkbox"
                                                :value="props.row.id"
                                                v-model="checked_certificate"
                                                v-on:input="certificateCheckchange(props.row)"
                                              />
                                            </span>
                                          </template>
                                        </el-table-column> -->
                    <el-table-column min-width="250px" align="left" label="Course Name">
                      <template slot-scope="props">
                        <span>{{ props.row.certificate_name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200px" align="left" label="Completion Date">
                      <template slot-scope="props">
                        <span class="lesson-status-open">{{
                          formattedDate(props.row.certificate_date)
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200px" align="left" label="Expiration Date">
                      <template slot-scope="props">
                        <span class="lesson-status-expired">{{
                          formattedDate(props.row.certificate_expiration_date)
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200px" align="left" label="Action">
                      <div slot-scope="{ row }" class="actions-container">
                        <el-tooltip content="Preview" placement="top">
                          <base-button
                            @click="generatePreviewCertificate(row.course_id, user_id, row.id, row.is_coursefolder)"
                            class="success" type="" size="sm" icon data-toggle="tooltip" data-original-title="Preview">
                            <img class="ico-eye" src="/img/icons/common/eye_icon.svg" alt="" />
                            <!-- <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M21.8358 10.2492C21.031 8.48925 17.8749 2.75 10.9999 2.75C4.12488 2.75 0.968799 8.48925 0.163965 10.2492C0.0559254 10.4851 0 10.7415 0 11.0009C0 11.2603 0.0559254 11.5167 0.163965 11.7526C0.968799 13.5108 4.12488 19.25 10.9999 19.25C17.8749 19.25 21.031 13.5108 21.8358 11.7508C21.9436 11.5152 21.9994 11.2591 21.9994 11C21.9994 10.7409 21.9436 10.4848 21.8358 10.2492ZM10.9999 17.4167C5.21847 17.4167 2.52072 12.4978 1.83322 11.0101C2.52072 9.50217 5.21847 4.58333 10.9999 4.58333C16.7675 4.58333 19.4662 9.48108 20.1665 11C19.4662 12.5189 16.7675 17.4167 10.9999 17.4167Z"
                                fill="#6D6D6D" />
                              <path
                                d="M10.9998 6.4165C10.0933 6.4165 9.2072 6.68531 8.45348 7.18893C7.69975 7.69256 7.11229 8.40838 6.76539 9.24587C6.41849 10.0834 6.32772 11.0049 6.50457 11.894C6.68142 12.7831 7.11794 13.5998 7.75893 14.2407C8.39992 14.8817 9.2166 15.3183 10.1057 15.4951C10.9948 15.672 11.9163 15.5812 12.7538 15.2343C13.5913 14.8874 14.3071 14.2999 14.8107 13.5462C15.3144 12.7925 15.5832 11.9063 15.5832 10.9998C15.5817 9.78471 15.0984 8.61977 14.2391 7.76054C13.3799 6.90131 12.215 6.41796 10.9998 6.4165ZM10.9998 13.7498C10.4559 13.7498 9.92426 13.5886 9.47202 13.2864C9.01979 12.9842 8.66731 12.5547 8.45917 12.0522C8.25103 11.5497 8.19657 10.9968 8.30268 10.4633C8.40879 9.92989 8.6707 9.43989 9.05529 9.05529C9.43989 8.6707 9.92989 8.40879 10.4633 8.30268C10.9968 8.19657 11.5497 8.25103 12.0522 8.45917C12.5547 8.66731 12.9842 9.01978 13.2864 9.47202C13.5886 9.92425 13.7498 10.4559 13.7498 10.9998C13.7498 11.7292 13.4601 12.4287 12.9444 12.9444C12.4287 13.4601 11.7292 13.7498 10.9998 13.7498Z"
                                fill="#6D6D6D" />
                            </svg> -->

                          </base-button>

                        </el-tooltip>
                        <el-tooltip content="Download" placement="top">
                          <base-button
                            @click="generateDownloadCertificate(row.course_id, user_id, row.id, row.is_coursefolder)"
                            class="warning" type="" size="sm" icon data-toggle="tooltip" data-original-title="Download">
                            <img class="ico-download" src="/img/icons/common/download_icon.svg" alt="" />
                            <!-- <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_485_979)">
                                <path
                                  d="M16.4762 6.55046C16.1728 6.48996 15.9243 6.30021 15.796 6.02888C14.3752 3.03046 11.0816 1.35388 7.78983 1.96071C4.7905 2.51071 2.43925 4.90504 1.93783 7.91996C1.78933 8.81004 1.80033 9.70104 1.96808 10.5691C2.02308 10.8524 1.90117 11.1677 1.65092 11.395C0.601333 12.3493 0 13.7087 0 15.1259C0 17.9052 2.26142 20.1675 5.04167 20.1675H15.125C18.9163 20.1675 22 17.0839 22 13.2925C22 10.0246 19.6772 7.18846 16.4762 6.55046ZM15.125 18.3333H5.04167C3.2725 18.3333 1.83333 16.8941 1.83333 15.125C1.83333 14.2239 2.2165 13.3576 2.88383 12.7508C3.60433 12.0954 3.94258 11.1255 3.76658 10.218C3.64008 9.56538 3.63275 8.89346 3.74458 8.21879C4.114 5.99863 5.9125 4.16621 8.118 3.76196C8.47092 3.69779 8.822 3.66663 9.1685 3.66663C11.2878 3.66663 13.2064 4.84821 14.1387 6.81446C14.5173 7.61379 15.2387 8.17296 16.1168 8.34804C18.4635 8.81646 20.1658 10.8955 20.1658 13.2925C20.1658 16.0719 17.9034 18.3342 15.1241 18.3342L15.125 18.3333ZM13.8609 11.2685C14.2193 11.627 14.2193 12.2063 13.8609 12.5647C13.6822 12.7435 13.4475 12.8333 13.2128 12.8333C12.9782 12.8333 12.7435 12.7435 12.5647 12.5647L11 11V15.5833C11 16.0902 10.5893 16.5 10.0833 16.5C9.57733 16.5 9.16667 16.0902 9.16667 15.5833V11L7.60192 12.5647C7.2435 12.9231 6.66417 12.9231 6.30575 12.5647C5.94733 12.2063 5.94733 11.627 6.30575 11.2685L8.78717 8.78713C9.141 8.4333 9.60575 8.25546 10.0705 8.25271L10.0833 8.24996L10.0962 8.25271C10.5618 8.25546 11.0257 8.4333 11.3795 8.78713L13.8609 11.2685Z"
                                  fill="#6D6D6D" />
                              </g>
                              <defs>
                                <clipPath id="clip0_485_979">
                                  <rect width="22" height="22" fill="white" />
                                </clipPath>
                              </defs>
                            </svg> -->


                          </base-button>
                        </el-tooltip>
                      </div>

                    </el-table-column>
                  </el-table>
                </div>
              </div>

            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="expired-certificate" v-if="is_expired_show">
      <div>
        <card class="no-border-card card-with-table" footer-classes="pt-1">
          <!-- <div class="row align-items-center">
                            <div class="col-md-6">
                                <h2 class="mb-1 px-4">Active Certificates</h2>
                            </div>

                            <div class="col-md-6 text-right">
                                <template v-if="isCertficateChecked">
                                    <a
                                        :href="
                      baseUrl +
                        '/downloadAllCourseCertificate/single/' +
                        checked_certificate.join('_') +
                        '/' +
                        user_id
                    "
                                        class="btn base-button custom-btn btn-default"
                                        type="primary"
                                    >Download<i class=" fa fa-download"></i
                                    ></a>
                                </template>
                            </div>
                        </div> -->
          <div>
            <!--<div class="row align-items-center justify-content-between mb-2">

                             <div class=" col-md-6   col-6 text-right">
                              <input type="checkbox" v-model="selectAll" @click="select" />
                              Check All
                            </div>
                        </div>-->
            <div class="row">

              <div class="col-sm-12 mt-2">
                <div class="user-eltable table-style-normal no-header-bg">
                  <h2 class="mb-3 px-4">Expired Certificates</h2>
                  <el-table header-row-class-name="thead-light custom-thead-light"
                    class="thead-light custom-thead-light addcertificatesGrid" role="table" :data="expiredData">
                    <!-- <el-table-column min-width="100px" label="">
                                          <template slot-scope="props">
                                            <span>
                                              <input
                                                type="checkbox"
                                                :value="props.row.id"
                                                v-model="checked_certificate"
                                                v-on:input="certificateCheckchange(props.row)"
                                              />
                                            </span>
                                          </template>
                                        </el-table-column> -->

                    <el-table-column min-width="250px" align="left" label="Course Name">
                      <template slot-scope="props">
                        <span>{{ props.row.certificate_name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200px" align="left" label="Completion Date">
                      <template slot-scope="props">
                        <span class="lesson-status-open">{{
                          formattedDate(props.row.certificate_date)
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200px" align="left" label="Expiration Date">
                      <template slot-scope="props">
                        <span class="lesson-status-expired">{{
                          formattedDate(props.row.certificate_expiration_date)
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="200px" align="left" label="Action">
                      <div slot-scope="{ row }" class="actions-container">
                        <el-tooltip content="Preview" placement="top">
                          <base-button v-if="row.is_proctored_exam == 1" @click.prevent="getProctoredExamCertificate(
                            row.certificate_url,
                            2
                          )" class="success" type="" size="sm" icon data-toggle="tooltip"
                            data-original-title="Preview">
                            <i class="text-success fa fa-eye" v-if="!row.show_loader"></i>
                            <i class="text-success fas fa-spin fa-spinner" v-if="row.show_loader"></i>
                          </base-button>
                          <base-button v-else
                            @click="generatePreviewCertificate(row.course_id, user_id, row.id, row.is_coursefolder)"
                            class="success" type="" size="sm" icon data-toggle="tooltip" data-original-title="Preview">
                            <img class="ico-eye" src="/img/icons/common/eye_icon.svg" alt="" />
                            <!-- <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M21.8358 10.2492C21.031 8.48925 17.8749 2.75 10.9999 2.75C4.12488 2.75 0.968799 8.48925 0.163965 10.2492C0.0559254 10.4851 0 10.7415 0 11.0009C0 11.2603 0.0559254 11.5167 0.163965 11.7526C0.968799 13.5108 4.12488 19.25 10.9999 19.25C17.8749 19.25 21.031 13.5108 21.8358 11.7508C21.9436 11.5152 21.9994 11.2591 21.9994 11C21.9994 10.7409 21.9436 10.4848 21.8358 10.2492ZM10.9999 17.4167C5.21847 17.4167 2.52072 12.4978 1.83322 11.0101C2.52072 9.50217 5.21847 4.58333 10.9999 4.58333C16.7675 4.58333 19.4662 9.48108 20.1665 11C19.4662 12.5189 16.7675 17.4167 10.9999 17.4167Z"
                                fill="#6D6D6D" />
                              <path
                                d="M10.9998 6.4165C10.0933 6.4165 9.2072 6.68531 8.45348 7.18893C7.69975 7.69256 7.11229 8.40838 6.76539 9.24587C6.41849 10.0834 6.32772 11.0049 6.50457 11.894C6.68142 12.7831 7.11794 13.5998 7.75893 14.2407C8.39992 14.8817 9.2166 15.3183 10.1057 15.4951C10.9948 15.672 11.9163 15.5812 12.7538 15.2343C13.5913 14.8874 14.3071 14.2999 14.8107 13.5462C15.3144 12.7925 15.5832 11.9063 15.5832 10.9998C15.5817 9.78471 15.0984 8.61977 14.2391 7.76054C13.3799 6.90131 12.215 6.41796 10.9998 6.4165ZM10.9998 13.7498C10.4559 13.7498 9.92426 13.5886 9.47202 13.2864C9.01979 12.9842 8.66731 12.5547 8.45917 12.0522C8.25103 11.5497 8.19657 10.9968 8.30268 10.4633C8.40879 9.92989 8.6707 9.43989 9.05529 9.05529C9.43989 8.6707 9.92989 8.40879 10.4633 8.30268C10.9968 8.19657 11.5497 8.25103 12.0522 8.45917C12.5547 8.66731 12.9842 9.01978 13.2864 9.47202C13.5886 9.92425 13.7498 10.4559 13.7498 10.9998C13.7498 11.7292 13.4601 12.4287 12.9444 12.9444C12.4287 13.4601 11.7292 13.7498 10.9998 13.7498Z"
                                fill="#6D6D6D" />
                            </svg> -->
                          </base-button>
                        </el-tooltip>
                        <el-tooltip content="Download" placement="top">
                          <base-button v-if="
                            row.is_proctored_exam != 1
                          " @click="generateDownloadCertificate(row.course_id, user_id, row.id, row.is_coursefolder)"
                            class="warning" type="" size="sm" icon data-toggle="tooltip" data-original-title="Download">
                            <img class="ico-download" src="/img/icons/common/download_icon.svg" alt="" />
                            <!-- <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_485_979)">
                                <path
                                  d="M16.4762 6.55046C16.1728 6.48996 15.9243 6.30021 15.796 6.02888C14.3752 3.03046 11.0816 1.35388 7.78983 1.96071C4.7905 2.51071 2.43925 4.90504 1.93783 7.91996C1.78933 8.81004 1.80033 9.70104 1.96808 10.5691C2.02308 10.8524 1.90117 11.1677 1.65092 11.395C0.601333 12.3493 0 13.7087 0 15.1259C0 17.9052 2.26142 20.1675 5.04167 20.1675H15.125C18.9163 20.1675 22 17.0839 22 13.2925C22 10.0246 19.6772 7.18846 16.4762 6.55046ZM15.125 18.3333H5.04167C3.2725 18.3333 1.83333 16.8941 1.83333 15.125C1.83333 14.2239 2.2165 13.3576 2.88383 12.7508C3.60433 12.0954 3.94258 11.1255 3.76658 10.218C3.64008 9.56538 3.63275 8.89346 3.74458 8.21879C4.114 5.99863 5.9125 4.16621 8.118 3.76196C8.47092 3.69779 8.822 3.66663 9.1685 3.66663C11.2878 3.66663 13.2064 4.84821 14.1387 6.81446C14.5173 7.61379 15.2387 8.17296 16.1168 8.34804C18.4635 8.81646 20.1658 10.8955 20.1658 13.2925C20.1658 16.0719 17.9034 18.3342 15.1241 18.3342L15.125 18.3333ZM13.8609 11.2685C14.2193 11.627 14.2193 12.2063 13.8609 12.5647C13.6822 12.7435 13.4475 12.8333 13.2128 12.8333C12.9782 12.8333 12.7435 12.7435 12.5647 12.5647L11 11V15.5833C11 16.0902 10.5893 16.5 10.0833 16.5C9.57733 16.5 9.16667 16.0902 9.16667 15.5833V11L7.60192 12.5647C7.2435 12.9231 6.66417 12.9231 6.30575 12.5647C5.94733 12.2063 5.94733 11.627 6.30575 11.2685L8.78717 8.78713C9.141 8.4333 9.60575 8.25546 10.0705 8.25271L10.0833 8.24996L10.0962 8.25271C10.5618 8.25546 11.0257 8.4333 11.3795 8.78713L13.8609 11.2685Z"
                                  fill="#6D6D6D" />
                              </g>
                              <defs>
                                <clipPath id="clip0_485_979">
                                  <rect width="22" height="22" fill="white" />
                                </clipPath>
                              </defs>
                            </svg> -->
                          </base-button>

                        </el-tooltip>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
    <!-- <div class="activated-certificate">
            <div>
                <card class="no-border-card card-with-table" footer-classes="pt-1">
                        <div class="row align-items-center">
                            <div class="col-md-6">
                                <h2 class="mb-1 px-4">Active Certificates</h2>
                            </div>

                            <div class="col-md-6 text-right">
                                <template v-if="isCertficateChecked">
                                    <a
                                        :href="
                      baseUrl +
                        '/downloadAllCourseCertificate/single/' +
                        checked_certificate.join('_') +
                        '/' +
                        user_id
                    "
                                        class="btn base-button custom-btn btn-default"
                                        type="primary"
                                    >Download<i class=" fa fa-download"></i
                                    ></a>
                                </template>
                            </div>
                        </div>
                    <div>
                        <div class="row align-items-center justify-content-between mb-2">

                             <div class=" col-md-6   col-6 text-right">
                              <input type="checkbox" v-model="selectAll" @click="select" />
                              Check All
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 mt-2">
                                <div class="user-eltable table-style-normal no-header-bg">
                                    <el-table
                                    :data="queriedData"
                                        row-key="id"
                                        role="table"
                                        class="certificatesGrid"
                                        header-row-class-name="thead-light custom-thead-light"
                                        @sort-change="sortChange"
                                        @selection-change="selectionChange"
                                    >
                                         <el-table-column min-width="100px" label="">
                                          <template slot-scope="props">
                                            <span>
                                              <input
                                                type="checkbox"
                                                :value="props.row.id"
                                                v-model="checked_certificate"
                                                v-on:input="certificateCheckchange(props.row)"
                                              />
                                              <i class="form-icon"></i>
                                            </span>
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="250px"
                                            align="left"
                                            label="Course Name"
                                        >
                                            <template slot-scope="props">
                                                <span>{{ props.row.certificate_name }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="200px"
                                            align="left"
                                            label="Completion Date"
                                        >
                                            <template slot-scope="props">
                        <span>{{
                                formattedDate(props.row.certificate_date)
                            }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="200px"
                                            align="left"
                                            label="Expiration Date"
                                        >
                                            <template slot-scope="props">
                        <span>{{
                                formattedDate(props.row.certificate_expiration_date)
                            }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="200px"
                                            align="left"
                                            label="Action"
                                        >
                                            <div slot-scope="{ row }" class="d-flex custom-size">
                                                <div v-if="row.is_certificate_approved === 1">
                                                    <el-tooltip content="Preview" placement="top">
                                                        <base-button
                                                            v-if="row.is_proctored_exam == 1"
                                                            @click.prevent="getProctoredExamCertificate(row.certificate_url,1)"
                                                            class="success"
                                                            type=""
                                                            size="sm"
                                                            icon
                                                            data-toggle="tooltip"
                                                            data-original-title="Preview"
                                                        >
                                                            <i v-if="!row.show_loader" class="text-success fa fa-eye"></i>
                                                            <i v-if="row.show_loader" class="text-success fas fa-spin fa-spinner"></i>
                                                        </base-button>
                                                        <base-button
                                                            v-else
                                                            @click="generatePreviewCertificate(row.course_id,user_id,row.id,row.is_coursefolder)"
                                                            class="success"
                                                            type=""
                                                            size="sm"
                                                            icon
                                                            data-toggle="tooltip"
                                                            data-original-title="Preview"
                                                        >
                                                            <i class="text-success fa fa-eye"></i>
                                                        </base-button>
                                                    </el-tooltip>
                                                    <el-tooltip content="Download" placement="top">
                                                        <base-button
                                                            v-if="row.is_proctored_exam != 1"
                                                            @click="generateDownloadCertificate(row.course_id,user_id,row.id,row.is_coursefolder)"
                                                            class="warning"
                                                            type=""
                                                            size="sm"
                                                            icon
                                                            data-toggle="tooltip"
                                                            data-original-title="Download"
                                                        >
                                                            <i class="text-warning fa fa-download"></i>
                                                        </base-button>
                                                    </el-tooltip>
                                                </div>
                                                <div v-else>
                                                    Generating Certificate
                                                </div>
                                            </div>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-2">

                                <div class="user-eltable">
                                    <h3 style="padding:10px;">Uploaded Certificates</h3>
                                    <el-table
                                        header-row-class-name="thead-light custom-thead-light"
                                        class="thead-light custom-thead-light addcertificatesGrid"
                                        role="table"
                                        :data="tbl2_data"
                                    >
                                        <el-table-column min-width="100px" label="">
                                          <template slot-scope="props">
                                            <span>
                                              <input
                                                type="checkbox"
                                                :value="props.row.id"
                                                v-model="checked_certificate"
                                                v-on:input="certificateCheckchange(props.row)"
                                              />
                                            </span>
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="250px"
                                            align="left"
                                            label="Course Name"
                                        >
                                            <template slot-scope="props">
                                                <span>{{ props.row.certificate_name }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="200px"
                                            align="left"
                                            label="Completion Date"
                                        >
                                            <template slot-scope="props">
                        <span>{{
                                formattedDate(props.row.certificate_date)
                            }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="200px"
                                            align="left"
                                            label="Expiration Date"
                                        >
                                            <template slot-scope="props">
                        <span>{{
                                formattedDate(props.row.certificate_expiration_date)
                            }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="200px"
                                            align="left"
                                            label="Action"
                                        >
                                            <div slot-scope="{ row }" class="d-flex custom-size">
                                                <el-tooltip content="Preview" placement="top">
                                                    <base-button
                                                        @click="generatePreviewCertificate(row.course_id,user_id,row.id,row.is_coursefolder)"
                                                        class="success"
                                                        type=""
                                                        size="sm"
                                                        icon
                                                        data-toggle="tooltip"
                                                        data-original-title="Preview"
                                                    >
                                                        <i class="text-success fa fa-eye"></i>
                                                    </base-button>

                                                </el-tooltip>
                                                <el-tooltip content="Download" placement="top">
                                                    <base-button
                                                        @click="generateDownloadCertificate(row.course_id,user_id,row.id,row.is_coursefolder)"
                                                        class="warning"
                                                        type=""
                                                        size="sm"
                                                        icon
                                                        data-toggle="tooltip"
                                                        data-original-title="Download"
                                                    >
                                                        <i class="text-warning fa fa-download"></i>
                                                    </base-button>
                                                </el-tooltip>
                                            </div>

                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-2">
                                <div class="user-eltable">
                                    <h3 style="padding:10px;">Expired Certificates</h3>
                                    <el-table
                                        header-row-class-name="thead-light custom-thead-light"
                                        class="thead-light custom-thead-light addcertificatesGrid"
                                        role="table"
                                        :data="expiredData"
                                    >
                                         <el-table-column min-width="100px" label="">
                                          <template slot-scope="props">
                                            <span>
                                              <input
                                                type="checkbox"
                                                :value="props.row.id"
                                                v-model="checked_certificate"
                                                v-on:input="certificateCheckchange(props.row)"
                                              />
                                            </span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column
                                            min-width="250px"
                                            align="left"
                                            label="Course Name"
                                        >
                                            <template slot-scope="props">
                                                <span>{{ props.row.certificate_name }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="200px"
                                            align="left"
                                            label="Completion Date"
                                        >
                                            <template slot-scope="props">
                        <span>{{
                                formattedDate(props.row.certificate_date)
                            }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="200px"
                                            align="left"
                                            label="Expiration Date"
                                        >
                                            <template slot-scope="props">
                        <span>{{
                                formattedDate(props.row.certificate_expiration_date)
                            }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            min-width="200px"
                                            align="left"
                                            label="Action"
                                        >
                                            <div slot-scope="{ row }" class="d-flex custom-size">
                                                <el-tooltip content="Preview" placement="top">
                                                    <base-button
                                                        v-if="row.is_proctored_exam == 1"
                                                        @click.prevent="getProctoredExamCertificate(
                                    row.certificate_url,
                                    2
                                  )"
                                                        class="success"
                                                        type=""
                                                        size="sm"
                                                        icon
                                                        data-toggle="tooltip"
                                                        data-original-title="Preview"
                                                    >
                                                        <i class="text-success fa fa-eye" v-if="!row.show_loader"></i>
                                                        <i class="text-success fas fa-spin fa-spinner" v-if="row.show_loader"></i>
                                                    </base-button>
                                                    <base-button
                                                        v-else
                                                        @click="generatePreviewCertificate(row.course_id,user_id,row.id,row.is_coursefolder)"
                                                        class="success"
                                                        type=""
                                                        size="sm"
                                                        icon
                                                        data-toggle="tooltip"
                                                        data-original-title="Preview"
                                                    >
                                                        <i class="text-success fa fa-eye"></i>
                                                    </base-button>
                                                </el-tooltip>
                                                <el-tooltip content="Download" placement="top">
                                                    <base-button
                                                        v-if="
                                row.is_proctored_exam != 1
                              "
                                                        @click="generateDownloadCertificate(row.course_id,user_id,row.id,row.is_coursefolder)"
                                                        class="warning"
                                                        type=""
                                                        size="sm"
                                                        icon
                                                        data-toggle="tooltip"
                                                        data-original-title="Download"
                                                    >
                                                        <i class="text-warning fa fa-download"></i>
                                                    </base-button>

                                                </el-tooltip>
                                            </div>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </div> -->
  </div>
</template>
<script>
import moment from "moment";
import { formatDateLocal } from "@/util/dateFormatter";
import { Table, TableColumn, Select, Option } from "element-ui";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import "sweetalert2/src/sweetalert2.scss";

export default {
  mixins: [clientPaginationMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      loading: true,
      isCertficateChecked: false,
      baseUrl: this.$baseUrl,
      download_certificate: false,
      download_file_link: "",
      toolbarOptions: ["PdfExport"],
      allowPdfExport: true,
      uploadCertificateModal: false,
      hot_user: "",
      company_id: "",
      hot_token: "",
      user_id: "",
      config: "",
      certificate: {
        certificate_name: "",
        certificate_date: "",
        exp_date: "",
        certificate_file: "",
        course_id: ""
      },
      checked_certificate: [],
      tbl2_data: [],
      courses: [],
      tableData: [],
      expiredData: [],
      selectedRows: [],
      selected: [],
      selectAll: false,
      editor: "",
      course_ids: "",
      total_cer: '',
      active_cer: '',
      expire_cer: '',
      upload_cer: '',
      is_active_show: true,
      is_expired_show: false,
      is_uploaded_show: false,
    };
  },
  computed: {
    isSafeDig() {
      return process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
    },
    certificateIcons() {
      if (this.isSafeDig) {
        return {
          active: require('@/assets/safe-dig/svg-icons/active_certificate.svg'),
          expired: require('@/assets/safe-dig/svg-icons/expired_certificate.svg')
        };
      }
      return {
        active: 'img/svg-icons/active_certificate.svg',
        expired: 'img/svg-icons/expired_certificate.svg'
      };
    }
  },
  created: function () {

    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
      this.company_id = localStorage.getItem("hot-company-id");

      if (this.hot_user === "company-admin") {
        this.user_id = localStorage.getItem("hot-admin-id");
      } else {
        this.user_id = localStorage.getItem("hot-user-id");
      }
    }
    this.getCertificateCount();
    this.loading = true;
    this.$http
      .post("employees/certificates", {
        employee_id: this.user_id
      })
      .then(resp => {
        let certificate_data = resp.data.data;
        let expired_data = resp.data.data_expired;

        // Process active certificates
        let sortedCertificates = certificate_data.map(data => {
          return {
            id: data.id,
            course_id: data.course_id,
            certificate_date: data.certificate_date,
            certificate_expiration_date: data.certificate_expiration_date,
            is_coursefolder: data.is_coursefolder_certificate,
            certificate_url: data.certificate_url,
            certificate_name: data.is_coursefolder_certificate ? data.coursefolder.folder_name : data.course.name,
            certificate_no: data.certificate_no,
            is_proctored_exam: data.is_proctored_exam,
            show_loader: false,
            is_certificate_approved: data.is_certificate_approved,
          };
        }).sort((a, b) => a.certificate_name.localeCompare(b.certificate_name)); // Alphabetical sorting

        this.tableData = sortedCertificates;

        // Process expired certificates
        let sortedExpired = expired_data.map(data => {
          return {
            id: data.id,
            course_id: data.course_id,
            certificate_date: data.certificate_date,
            certificate_expiration_date: data.certificate_expiration_date,
            is_coursefolder: data.is_coursefolder_certificate,
            certificate_url: data.certificate_url,
            certificate_name: data.is_coursefolder_certificate ? data.coursefolder.folder_name : data.course.name,
            is_proctored_exam: data.is_proctored_exam,
            show_loader: false
          };
        }).sort((a, b) => a.certificate_name.localeCompare(b.certificate_name)); // Alphabetical sorting

        this.expiredData = sortedExpired;
      })
      .finally(() => (this.loading = false));


    this.$http
      .post("employees/additionalCertificates", {
        employee_id: this.user_id
      })
      .then(resp => {
        let certificate_data = resp.data.data;
        for (let data of certificate_data) {
          let obj = {
            id: data.id,
            course_id: data.course_id,
            certificate_date: data.certificate_date,
            certificate_expiration_date: data.certificate_expiration_date,
            certificate_url: data.certificate_url,
            certificate_name: data.course.name
          };
          this.tbl2_data.push(obj);
        }
      });
  },
  methods: {
    openActive() {
      this.is_active_show = true;
      this.is_expired_show = false;
      this.is_uploaded_show = false;
    },
    openExpired() {
      this.is_active_show = false;
      this.is_expired_show = true;
      this.is_uploaded_show = false;
    },
    openUploaded() {
      this.is_active_show = false;
      this.is_expired_show = false;
      this.is_uploaded_show = true;
    },
    getCertificateCount() {
      this.$http.post("/certificate-count", {
        employee_id: this.user_id
      }).then((res) => {
        this.total_cer = res.data.total;
        this.active_cer = res.data.active_certificate_count;
        this.expire_cer = res.data.expired_count;
        this.upload_cer = res.data.uploaded_certificate;
      });
    },
    formattedDate(data) {
      return formatDateLocal(data);
    },
    certificateCheckchange(row) {
      this.isCertficateChecked = true;
      if (this.checked_certificate.includes(row.id)) {
        this.checked_certificate.splice(
          this.checked_certificate.indexOf(row.id),
          1
        );
      } else {
        this.checked_certificate.push(row.id);
      }
      if (this.checked_certificate.length == 0) {
        this.isCertficateChecked = false;
      }
    },
    select() {
      this.checked_certificate = [];
      if (!this.selectAll) {
        this.isCertficateChecked = true;
        for (let i in this.tableData) {
          this.checked_certificate.push(this.tableData[i].id);
        }
        for (let i1 in this.tbl2_data) {
          this.checked_certificate.push(this.tbl2_data[i1].id);
        }
        for (let i1 in this.expiredData) {
          this.checked_certificate.push(this.expiredData[i1].id);
        }
      }
      if (this.checked_certificate.length === 0) {
        this.isCertficateChecked = false;
      }
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },

    getProctoredExamCertificate: function (certificateURL, action) {
      let certificateIndex = null;
      if (action == 1) {
        this.tableData.forEach(function (certificate, index) {
          if (certificate.certificate_url == certificateURL) {
            certificateIndex = index;
            return true;
          }
        });
        this.tableData[certificateIndex].show_loader = true;
      } else {
        this.expiredData.forEach(function (certificate, index) {
          if (certificate.certificate_url == certificateURL) {
            certificateIndex = index;
            return true;
          }
        });
        this.expiredData[certificateIndex].show_loader = true;
      }
      this.$http
        .post("course/proctored-exam-certificate", {
          certificateURL: certificateURL
        })
        .then(resp => {
          if (action == 1) {
            this.tableData[certificateIndex].show_loader = false;
          } else {
            this.expiredData[certificateIndex].show_loader = false;
          }
          window.open(resp.data.certificate_url, "_blank");
        });
    },
    generatePreviewCertificate(course_id, user_id, certificate_id, is_coursefolder) {
      window.open(this.baseUrl + '/downloadCourseCertificate/preview/' + course_id + '/' + user_id + '/' + certificate_id + '/' + is_coursefolder);
    },
    generateDownloadCertificate(course_id, user_id, certificate_id, is_coursefolder) {
      window.open(this.baseUrl + '/downloadCourseCertificate/download/' + course_id + '/' + user_id + '/' + certificate_id + '/' + is_coursefolder);
    },
    generateManualCertificate(url) {
      window.open(url);
    },
    downloadManualCertificate(url) {
      window.open(url, 'download');
    }
  }
};
</script>
<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}

@media only screen and (max-width: 1024px),
(min-device-width: 768px) and (max-device-width: 1024px) {
  /* .certificatesGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Check";
  } */

  .certificatesGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Course Name";
  }

  .certificatesGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Completion Date";
  }

  .certificatesGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Expirtion Date";
  }

  .certificatesGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "Actions";
  }

  /* .addcertificatesGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Check";
  } */

  .addcertificatesGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Course Name";
  }

  .addcertificatesGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Completion Date";
  }

  .addcertificatesGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Expirtion Date";
  }

  .addcertificatesGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "Actions";
  }
}
</style>
